// extracted by mini-css-extract-plugin
export var active = "_bb-7";
export var container = "_bb-0";
export var evenWidth = "_bb-4";
export var large = "_bb-5";
export var outlet = "_bb-8";
export var slide = "_bb-2";
export var small = "_bb-6";
export var tab = "_bb-3";
export var tabs = "_bb-1";